/**
 * The spreadsheet import's bounds as the drop zone states them (ai-plan-builder R26, R31; owner,
 * 5 October 2026: 2 MB). The server is the judge: these are `Ai:Import:MaxFileBytes` and
 * `:MaxSheets` at their defaults, and a refusal that names its own `limit` is worded with that number
 * instead (`lib/importWording.ts`).
 */
export const IMPORT_LIMITS = {
  maxFileBytes: 2 * 1024 * 1024,
  maxSheets: 10,
} as const;

/** What the file chooser offers. The server reads a file by its content, whatever it is called. */
export const SHEET_ACCEPT = '.xlsx,.csv,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
